import React from 'react';

const Content = () => (
  <>
          <section className="privacy-section">
            <h2>1) Controller (who we are)</h2>
            <p>
              Diddyinnovation Limited ("we", "us", "our") is the controller responsible for
              processing personal data in connection with this application (the "App").
            </p>
            <div className="contact-info">
              <p><strong>Company:</strong> Diddyinnovation Limited</p>
              <p><strong>Address:</strong> Coral Bay 91, 8575 Pegeia, Cyprus</p>
              <p><strong>Contact for privacy questions and requests:</strong> Profile → Contact (in-app contact form)</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>2) What the App does</h2>
            <p>
              The App provides "Online Waiter" services, including discovering participating
              restaurants, browsing menus, creating and managing orders, and supporting table service.
            </p>
            <p>
              Restaurants you interact with may also process certain personal data independently
              (for example, to prepare and serve your order, manage table service, comply with
              accounting obligations, and handle disputes). In those cases, the restaurant may
              act as a separate controller for its own processing.
            </p>
          </section>

          <section className="privacy-section">
            <h2>3) Personal data we process</h2>
            <p>Depending on how you use the App, we may process:</p>

            <h3>A. Account and identifiers</h3>
            <ul>
              <li>Email address</li>
              <li>Social sign-in identifiers (via Apple, Google, Facebook), depending on your choice and provider settings</li>
              <li>Internal identifiers (e.g., client ID, order ID, restaurant ID)</li>
            </ul>

            <h3>B. Order and service data</h3>
            <ul>
              <li>Restaurant selection and table number</li>
              <li>Ordered items, quantities, prices, VAT/tax information (where applicable), discounts, tips, totals, and currency</li>
              <li>Order status and timestamps</li>
              <li>Notes/comments you enter (free text)</li>
            </ul>

            <h3>C. Location data (optional)</h3>
            <ul>
              <li>Approximate or precise device location (depending on permissions) to show restaurants near you</li>
            </ul>

            <h3>D. Technical data</h3>
            <ul>
              <li>IP address, device/app data, log/diagnostic data necessary to operate, secure, and improve the service</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4) Location data</h2>
            <p>
              If you grant location permission, we use your device location to show restaurants
              near you. We do not store your location history as part of the core service, and
              we do not store your precise client location on the backend for tracking purposes.
            </p>
            <p>
              You can deny or withdraw location permission at any time via your device settings.
              If you do so, restaurant discovery based on proximity may be limited.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5) Purposes and legal bases (GDPR)</h2>
            <p>We process personal data for the following purposes and under the following legal bases:</p>

            <h3>A. Provide the service / perform a contract (GDPR Art. 6(1)(b))</h3>
            <ul>
              <li>Provide core App functionality (restaurant discovery, menus, ordering, order management)</li>
              <li>Support table service and communicate order status as part of the service</li>
            </ul>

            <h3>B. Consent (GDPR Art. 6(1)(a))</h3>
            <ul>
              <li>Device location access (where requested by the App/OS)</li>
            </ul>

            <h3>C. Legitimate interests (GDPR Art. 6(1)(f))</h3>
            <ul>
              <li>Maintain security, prevent abuse/fraud, troubleshoot issues, and ensure service reliability</li>
            </ul>

            <h3>D. Legal obligation (GDPR Art. 6(1)(c))</h3>
            <ul>
              <li>Comply with accounting/tax and other legal obligations where applicable</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6) Sharing of personal data</h2>
            <p>We may share personal data with:</p>

            <h3>A. Restaurants you interact with</h3>
            <p>
              To fulfill your order and provide table service (for example: order items,
              quantities, table number, notes, and relevant order status information).
            </p>

            <h3>B. Service providers (processors)</h3>
            <p>
              We use service providers to host and operate the App and related infrastructure.
            </p>
            <ul>
              <li><strong>Hosting/infrastructure:</strong> Amazon Web Services (AWS), region eu-central-1 (Frankfurt)</li>
            </ul>

            <h3>C. Legal and safety disclosures</h3>
            <p>
              We may disclose data where required by law or where necessary to protect rights,
              users, and the service.
            </p>

            <p className="highlight-note">We do not sell your personal data.</p>
          </section>

          <section className="privacy-section">
            <h2>7) Third-party sign-in (Apple, Google, Facebook)</h2>
            <p>
              If you choose to sign in using Apple, Google, or Facebook, those providers process
              data under their own privacy policies. They may provide us with sign-in identifiers
              and/or account information (such as your email address), depending on the permissions
              you grant and the provider's configuration.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8) International transfers</h2>
            <p>
              Our primary hosting region is AWS eu-central-1 (Frankfurt). If personal data is
              transferred outside the EEA in the future (for example, due to service provider
              infrastructure), we will apply appropriate safeguards such as Standard Contractual
              Clauses, where required.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9) Retention</h2>
            <p>
              We retain personal data only for as long as necessary for the purposes described
              in this Privacy Policy. Order and related financial records may be retained for
              up to 6 years from the end of the relevant financial year (or longer if required
              by law, audits, or dispute resolution).
            </p>
          </section>

          <section className="privacy-section">
            <h2>10) Security</h2>
            <p>
              We implement reasonable technical and organizational measures designed to protect
              personal data (for example, access controls and encryption in transit). No method
              of transmission or storage is fully secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11) Your rights (EU/EEA)</h2>
            <p>
              Subject to GDPR conditions and exceptions, you may have the right to request
              access, rectification, deletion, restriction, portability, and to object to
              certain processing. You may withdraw consent at any time (for example, location
              permission via device settings).
            </p>
            <p>
              To exercise your rights, contact us via <strong>Profile → Contact</strong> (in-app contact form).
              We may request information needed to verify your identity and locate your data.
            </p>
          </section>

          <section className="privacy-section">
            <h2>12) Complaints</h2>
            <p>
              You have the right to lodge a complaint with a supervisory authority in the
              EU/EEA, in particular in the Member State of your habitual residence, place of
              work, or the place of the alleged infringement.
            </p>
          </section>

          <section className="privacy-section">
            <h2>13) Children</h2>
            <p>
              The App is not intended for children. We do not knowingly collect personal data
              from children.
            </p>
          </section>

          <section className="privacy-section">
            <h2>14) Changes to this Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The latest version will be
              available at the Public URL shown at the top and within the App.
            </p>
          </section>

          <section className="privacy-section">
            <h2>15) Contact</h2>
            <div className="contact-info">
              <p><strong>Diddyinnovation Limited</strong></p>
              <p>Coral Bay 91</p>
              <p>8575 Pegeia</p>
              <p>Cyprus</p>
              <p><strong>Contact:</strong> Profile → Contact (in-app contact form)</p>
              <p>For general inquiries, visit our <a href="/contact">Contact Page</a></p>
            </div>
          </section>
  </>
);

export default Content;
